<template>
  <div @click="onClick" :class="[this.componentClass, this.isActive?this.activeClass:'','arrow:hover']">
    <svg
      v-if="this.isFirst"
      width="58.207mm"
      height="10.689mm"
      viewBox="0 0 58.207 10.689"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-22.566 -70.384)">
        <path
          d="m27.987 70.594 46.878 0.12976 5.5951 5.0143-5.6498 5.1253-46.878-0.12977c-11.642-5.2238 0.0547-10.14 0.0547-10.14z"
          pointer-events="all" stroke="#e8e8e8"
          stroke-miterlimit="10"
          stroke-width=".41958"
        />
      </g>
    </svg>
    <svg
      v-else-if="this.isLast" width="58.208mm"
      height="10.583mm"
      viewBox="0 0 58.208 10.583"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(20.821 -77.537)">
        <path
          d="m31.449 87.9h-51.688l5.7325-5.0715-5.7325-5.0712h51.688c12.867 5.1931 0 10.143 0 10.143z"
          pointer-events="all" stroke="#e8e8e8"
          stroke-miterlimit="10"
          stroke-width=".44064"/>
      </g>
    </svg>
    <svg
      v-else
      width="58.209mm"
      height="10.583mm"
      viewBox="0 0 58.209 10.583"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(22.005 -80.298)">
        <path
          d="m-21.424 80.518h51.567l5.7297 5.0716-5.7297 5.0716h-51.567l5.7297-5.0716z"
          pointer-events="all" stroke="#e8e8e8" stroke-miterlimit="10" stroke-width=".44014"/>
      </g>
    </svg>
    <span>{{ this.title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    activeClass: {
      type: String,
      required: false,
      default: 'active'
    },
    componentClass: {
      type: String,
      required: false,
      default: null
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: true
    },
  },
  methods: {
    onClick: function () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  position: relative;
  display: inline-flex;
  align-items: center;
}

div > span {
  position: absolute;
  margin-left: 40px;
  font-weight: bold;
  font-size: 14px;
}
</style>
